import { api } from './api';
import type { Etapa1Identifier } from './validacao-etapa1.service';

export interface SelecaoEtapa1 {
  _id: string;
  prefixo?: string;
  comite?: string;
  categoria: string;
  selectedBy: string;
  selectedByName: string;
  selectedByMatricula: string;
  selectedAt: number;
  justificativa: string;
  iniciativaIds: string[];
  iniciativaTitulos: string[];
  totalIniciativas: number;
  totalSelecionadas: number;
  supersededAt?: number;
}

export type SelecaoEtapa1Input = Omit<SelecaoEtapa1, '_id'>;

const COLLECTION = 'selecao_etapa1__c';

const identifierToMatch = (identifier: Etapa1Identifier): Record<string, string> | null => {
  const comite = identifier?.comite ? String(identifier.comite).trim() : '';
  if (comite) return { comite };
  const prefixo = identifier?.prefixo ? String(identifier.prefixo).trim() : '';
  if (prefixo) return { prefixo };
  return null;
};

export const submitSelecaoEtapa1 = async (
  payload: SelecaoEtapa1Input
): Promise<SelecaoEtapa1> => {
  const { data } = await api.post(`/database/${COLLECTION}`, payload);
  return data;
};

export const updateSelecaoEtapa1 = async (
  payload: SelecaoEtapa1
): Promise<SelecaoEtapa1> => {
  const { data } = await api.put(`/database/${COLLECTION}`, payload);
  return data;
};

export const fetchSelecaoById = async (id: string): Promise<SelecaoEtapa1 | null> => {
  const { data } = await api.post('/find/selecao_etapa1_by_id', { id });
  const results = Array.isArray(data) ? data : [];
  return results.length > 0 ? (results[0] as SelecaoEtapa1) : null;
};

export const markSelecaoAsSuperseded = async (id: string): Promise<void> => {
  const existing = await fetchSelecaoById(id);
  if (!existing) return;
  await api.put(`/database/${COLLECTION}`, { ...existing, supersededAt: Date.now() });
};

export const fetchSelecaoByPrefixoCategoria = async (
  identifier: Etapa1Identifier,
  categoria: string
): Promise<SelecaoEtapa1 | null> => {
  const match = identifierToMatch(identifier);
  if (!match) return null;

  const { data } = await api.post('/find/selecao_etapa1_by_escopo_categoria', {
    ...match,
    categoria,
  });

  const results = Array.isArray(data) ? data : [];
  return results.length > 0 ? (results[0] as SelecaoEtapa1) : null;
};

export const fetchCategoriasCompletadas = async (
  identifier: Etapa1Identifier,
  categorias: string[]
): Promise<string[]> => {
  const match = identifierToMatch(identifier);
  if (!match) return [];

  const { data } = await api.post('/find/selecao_etapa1_categorias_completadas', {
    ...match,
    categorias,
  });

  const results = Array.isArray(data) ? data : [];
  return results.map((r: any) => r._id as string);
};

export const fetchAllSelecoesByPrefixo = async (
  identifier: Etapa1Identifier
): Promise<SelecaoEtapa1[]> => {
  const match = identifierToMatch(identifier);
  if (!match) return [];

  const { data } = await api.post('/find/selecoes_etapa1_by_escopo', { ...match });

  return Array.isArray(data) ? (data as SelecaoEtapa1[]) : [];
};
